import React from 'react'

const Loader = () => {
	return(
		<center>
		<div className="preloader-wrapper big active">
			<div className="spinner-layer spinner-orange-only">
				<div className="circle-clipper left">
					<div className="circle"></div>
				</div>
				<div className="gap-patch">
					<div className="circle"></div>
				</div>
				<div className="circle-clipper right">
					<div className="circle"></div>
				</div>
			</div>
		</div>
		</center>
	)
}

export default Loader
